import React, {useRef, useState} from 'react';
import Navigation from './Navigation';
import "../style/MediaQueries.css";
import "../style/App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import {IconText} from "../../data/IconText";
import Footer from "./Footer";
import Goo from 'gooey-react'


function App(this: any) {
    const slider = useRef(null)
    const nofSlides = () => {
        const width = window.innerWidth;
        switch (true) {
            case width < 600:
                return 1;
            case width < 1000:
                return 2;
            default :
                return 3;
        }
    }

    let [scal, setScal] = useState(0);

    function showForm() {
        scal = 1;
        setScal(scal);
    }

    function delForm(event:any) {
        scal = 0;
        event.preventDefault();
        setScal(scal);
    }

    let [tPos1, setPos1] = useState("30px");
    let [tPos2, setPos2] = useState("30px");
    let [tPos3, setPos3] = useState("30px");


    let [lPos1, setLPos1] = useState("20px");
    let [lPos2, setLPos2] = useState("20px");
    let [lPos3, setLPos3] = useState("20px");

    let [rot, setrot] = useState("rotate(0deg)");
    let [status, setStatus] = useState("off");


    let [input1, setInp] = useState("");
    let [input2, setInp2] = useState("");
    let [input3, setInp3] = useState("");

    let [attr, setAttr] = useState("btn btn-success");

    let [borcolor1, setColor1] = useState("");
    let [borcolor2, setColor2] = useState("");
    let [borcolor3, setColor3] = useState("");
    function valiDate(event:any){
            if(event.target.name==="name"){
                if(event.target.value.match(/^[a-zA-Z ]{2,30}$/)){
                    setInp("");
                    setAttr("btn btn-success");
                    setColor1("green");
                }
                else{
                    setInp("Digits/Special Characters Not Allowed !");
                    setColor1("red");
                    setAttr("btn btn-success disabled");
                }
            }
            else if(event.target.name==="email"){
                if(event.target.value.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)){
                    setInp2("");
                    setAttr("btn btn-success");
                    setColor2("green");
                }
                else{
                    setInp2("Email Address Is Invalid !");
                    setColor2("red");
                    setAttr("btn btn-success disabled");
                }
            }
            else if(event.target.name==="contactno"){
                if(event.target.value.length===10){
                    setInp3("");
                    setAttr("btn btn-success");
                    setColor3("green");
                }
                else{
                    setInp3("Should Be Of 10 Digits !");
                    setColor3("red");
                    setAttr("btn btn-success disabled");
                }
            }

    }

    function showFloat(event: any) {
        // alert(event.target.id);
        if (event.target.id === "off") {
            tPos1 = "30px";
            tPos2 = "100px";
            tPos3 = "130px";

            lPos1 = "120px";
            lPos2 = "90px";
            lPos3 = "20px";
            setStatus("on");
            setrot("rotate(360deg)");
            setPos1(tPos1);
            setPos2(tPos2);
            setPos3(tPos3);

            setLPos1(lPos1);
            setLPos2(lPos2);
            setLPos3(lPos3);
        } else if (event.target.id === "on") {
            tPos1 = "30px";
            tPos2 = "30px";
            tPos3 = "30px";
            setrot("rotate(0deg)");
            lPos1 = "20px";
            lPos2 = "20px";
            lPos3 = "20px";
            setStatus("off");
            setPos1(tPos1);
            setPos2(tPos2);
            setPos3(tPos3);

            setLPos1(lPos1);
            setLPos2(lPos2);
            setLPos3(lPos3);

        }
    }

    const slides: Array<IconText> = [
        new IconText("Real Estate Developers", "flaticon-home-repair"),
        new IconText("Real Estate Consultants", "flaticon-sales"),
        new IconText("Services For Construction", "flaticon-bank"),
        new IconText("Renovation Services in Jalandhar", "flaticon-team"),
        new IconText("Real Estate Contractors", "flaticon-home-repair"),
        new IconText("Real Estate Legal Consultancy", "flaticon-sales"),
        new IconText("Real Estate Insurance Services", "flaticon-team"),
        new IconText("Real Estate Loan Consultancy", "flaticon-bank"),
    ]

    const rotStyle: any = {
        transform: rot,
        WebkitTransform: rot,
        msTransform: rot
    }
    return (
        <div>


            {/*FAB - INQUIRIES*/}
            <div id="mySidenav">

                <button id="contactform" style={{bottom: tPos1, right: lPos1}} onClick={showForm}><i
                    className="fa fa-envelope"/></button>
                <a href={"https://www.facebook.com/dreamhomecolonisers"} target='_blank'>
                    <button id="facebook" style={{bottom: tPos2, right: lPos2}}><i className="fa fa-facebook"/></button>
                </a>
                <a href={"https://wa.me/+919041917502"} target='_blank'>
                    <button id="whatsapp" style={{bottom: tPos3, right: lPos3}}>
                        <i className="fa fa-whatsapp"/></button>
                </a>
                <button id={status} style={rotStyle} className="about" onClick={showFloat}><i
                    id={status}
                    className="fa fa-comments"/>
                </button>
            </div>

            {/*CONTACTUS MODAL*/}
            <div id="ModalForm" style={{transform: 'scale(' + scal + ',' + scal + ')'}} className="p-3">

                <form style={{background:"transparent",borderRadius:"5px",transform: ' translate(-50%,-50%)',position:"absolute",top:"50%",left:"50%"}} id="formm" className="p-3">
                    <button id="closebtnform" className="text-white  close" onClick={delForm}>&times;</button>
                    <div className="row">
                        <div className="col-12 text-center">
                            <h2 className=" text-lg-center text-white text-sm-center text-center font-weight-bold"><span style={{color:"#209441"}}>Feel Free </span>To Ask
                                Questions !</h2>
                        </div>
                        <div className="col-lg-6 col-sm-12 text-center">
                            <input type="text" placeholder="Your Full Name" className="form-control" style={{borderColor:borcolor1}} name="name" required onChange={valiDate}/>
                            <p/>
                            <p className="text-danger font-weight-bolder">{input1}</p>

                        </div>
                        <div className="col-lg-6 col-sm-12  text-center">
                            <input type="email" placeholder="Your Email" className="form-control" style={{borderColor:borcolor2}} name="email" required onChange={valiDate}/>
                            <p/>
                            <p className="text-danger font-weight-bolder">{input2}</p>
                        </div>

                        <div className="col-lg-6 col-sm-12  text-center">
                            <input type="number" placeholder="Your Mobile Number" className="form-control" style={{borderColor:borcolor3}} name="contactno" required onChange={valiDate}/>
                            <p/>
                            <p className="text-danger font-weight-bolder">{input3}</p>
                        </div>
                        <div className="col-lg-6 col-sm-12  text-center">
                            <input type="text" placeholder="Your Location" className="form-control" name="location" required/>
                            <p/>

                        </div>


                        <div className="col-12 text-center">
                            <textarea placeholder="Your Message" className="form-control" rows={5} required/>
                            <p/>
                        </div>
                        <div className="col-12 text-center pb-3">
                            <input type="submit" className={attr} style={{width: "100px"}} value="Submit"/>
                        </div>
                    </div>
                </form>
            </div>
            <Navigation/>
            {/*HOME*/}
            <section className="MainImgdiv">
                <div className="overlayy11"/>
                <img className="MainImg" src="./images/mainimg.jpg" alt={"background"}/>
                <div className="container" id="ImgContent">
                    <div className="row no-gutters slider-text align-items-center">
                        <div className="col-lg-12 col-md-6 ftco-animate d-flex align-items-end p-3">
                            <div className="text">
                                <h1 className="mb-4 mainText py-5">Turning your Real Estate Dreams into Reality.</h1>
                                <p className="mainText1">Be the owner of your Dream Home in just Rs. 2.67 lakhs!</p>
                                <p className="pt-5"><a href="#properties" className="btn btn-primary py-3 px-4">View all
                                    properties</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/*ABOUT US*/}
            <section className="ftco-section ftco-no-pb" id="aboutus">
                <div className="container">
                    <div className="row">
                        <div className="col-12 heading-section text-center ftco-animate">
                            <span className="subheading">Who We Are ?</span>
                            <h2 className="mb-2">About Us</h2>
                        </div>
                        <div className="col-1"/>
                        <div
                            className="col-10 wrap-about py-xl-5 py-lg-5 py-md-5 py-sm-5 py-0 ftco-animate text-center">

                            <div className="heading-section pr-md-5 text-center my-5">
                                <h2 className="mb-4 text-left text-center whitespace">Dream Home <span
                                    className="text-success"> Real Estate </span></h2>

                                <p className="simple-text">Dreamhome Developers & Colonisers is a company that has come
                                    into being to turn the
                                    real estate dreams of normal people in our society into actual realities. The vision
                                    to provide affordable and modern housing to everyone led to the formation of this
                                    company!</p>
                                <p className="simple-text">With over an experience of 30 years, the team of Dreamhome
                                    started this organization
                                    to actualize their mission. They are licensed colonizers who work with transparency,
                                    honesty and credibility. They focus on delivering high quality standards by
                                    following meticulously planned approach. We value the faith of our clients and
                                    ensure timely delivery of innovative & quality products.</p>
                                <p className="simple-text">We are here to build vibrant communities that redefine real
                                    estate development in
                                    Punjab.</p>

                            </div>
                            <a className="btn btn-success m-auto text-white" href="/about">Know More</a>
                        </div>
                    </div>
                </div>
                <div className="col-1"/>
            </section>

            {/*SERVICES*/}
            <section className="ftco-section ftco-no-pb ftco-no-pt  py-5 " id="services" style={{height: "100%"}}>
                <div className="col-md-12 heading-section text-center ftco-animate mb-5">
                    <span className="subheading">What we offer ?</span>
                    <h2 className="mb-2">Our Services</h2>
                </div>

                <div className="container" style={{background: 'white'}}>
                    <div>
                        <div className="container" style={{background: 'white'}}>
                            <Slider ref={slider}
                                    slidesToShow={nofSlides()}
                                    infinite={true}
                                    autoplaySpeed={3000}
                                    autoplay={true}>

                                {slides.map((value => {
                                    return <div
                                        className="media block-6 services services-bg d-block text-center services-darken py-4 cardds1">
                                        <div className="subcard1">
                                            <div
                                                className="icon d-flex justify-content-center align-items-center mt-3">
                                                <span className={value.icon}/>
                                            </div>
                                            <div className="media-body py-md-4">
                                                <h5 className="text-light">{value.text}</h5>
                                            </div>
                                        </div>
                                    </div>
                                }))}

                            </Slider>

                        </div>

                    </div>
                    <div className="row">
                        <div className="col-12 mt-5 text-center"><a href="/services" className="btn btn-success">Know
                            More</a></div>
                    </div>
                </div>
            </section>

            <section className="ftco-section ftco-no-pb" style={{background: "#10101c"}} id="projects">
                <div className="container">
                    <div className="row justify-content-center">

                        <div className="col-md-12 heading-section text-center ftco-animate mb-2">
                            <span className="subheading">Our Projects</span>
                            <h2 className="mb-2 text-white">Vajra Vihar</h2>
                        </div>
                    </div>
                    <div className="row">
                        {/*<div className="col-md-7 order-md-last d-flex align-items-stretch">*/}
                        {/*  <div className="img w-100 img-2 mr-md-2" style={{ backgroundImage: 'url(images/about.jpg' }}></div>*/}
                        {/*  <div className="img w-100 img-2 ml-md-2" style={{ backgroundImage: 'url(images/about-2.jpg' }}></div>*/}
                        {/*</div>*/}
                        <div className="col-md-12 wrap-about py-md-5 ftco-animate p-4">
                            <div className="heading-section text-center text-white-50" style={{fontSize: "large"}}>
                                <p className="text-justify">
                                    Vajra Vihar is a Government Approved & Licensed Colonisation. It is an initiative to
                                    promote affordable housing solutions. It is a venture build and managed by highly
                                    skilled professionals. Maintaining its high standards in quality construction and
                                    customer satisfaction, the Dreamhome team tends <span className="mobview">forward to literally.</span></p>
                                <p className="text-center nonmobview" style={{transform:"translateY(-15px)"}}>forward to literally.
                                </p>
                                <h4 className="text-white text-center">
                                    <span className="fa fa-quote-left text-success"
                                          style={{transform: "translate(-5px,-10px)"}}> </span> Turn all your Real
                                    Estates<br className="d-block d-lg-none d-md-none d-sm-none"/>
                                    <span className="pl-4 pl-lg-0 pl-md-0 pl-sm-0"> Dreams into Reality</span> <span
                                    className="fa fa-quote-right text-success pl-1 pl-lg-0 pl-md-0 pl-sm-0"
                                    style={{transform: "translateY(-10px)"}}/>
                                </h4>
                                <p></p>
                                <p className="text-justify">It created especially for people who have taste and an eye for quality. Loaded with
                                    world class living amenities, we have precisely planned every detail so that each
                                    home makes a statement.Vajra Vihar is the perfect home for families looking for a great lifestyle at a great
                                    location. Plus, it offers all that <span className="mobview">an upward moving colony needs at a price that
                                    won’t make a hole in your pocket.</span></p>
                                <p className="text-center nonmobview" style={{transform:"translateY(-15px)"}}>an upward moving colony needs at a price that
                                    won’t make a hole in your pocket.</p>
                                <a href="/VajraVihar" className="btn btn-success">Know More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/*PROPERTIES*/}
            <section className="ftco-section bg-darken" id="properties">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-12 heading-section heading-section-white text-center ftco-animate mb-5">
                            <span className="subheading">What we offer ?</span>
                            <h2 className="mb-2">Featured Properties</h2>
                        </div>
                    </div>
                    <div className="row ftco-animate">
                        <div className="col-md-12">
                            <div className="carousel-properties owl-carousel">
                                <div className="item ii">
                                    <div className="property-wrap ftco-animate">
                                        <a href="test" className="img"
                                           style={{backgroundImage: 'url(images/work-1.jpg)'}}>
                                            <div className="rent-sale">
                                                <span className="sale">Sale</span>
                                            </div>
                                            <p className="price"><span className="orig-price">$300,000</span></p>
                                        </a>
                                        <div className="text">
                                            <ul className="property_list">
                                                <li><span className="flaticon-bed"/>3</li>
                                                <li><span className="flaticon-bathtub"/>2</li>
                                                <li><span className="flaticon-floor-plan"/>1,878 sqft</li>
                                            </ul>
                                            <h3><a href="test">The Blue Sky Home</a></h3>
                                            <span className="location">Oakland</span>
                                            <a href="test"
                                               className="d-flex align-items-center justify-content-center btn-custom">
                                                <span className="fa fa-link"/>
                                            </a>
                                            <div className="list-team d-flex align-items-center mt-2 pt-2 border-top">
                                                <div className="d-flex align-items-center">
                                                    <div className="img"
                                                         style={{backgroundImage: 'url(images/person_1.jpg)'}}/>
                                                    <h3 className="ml-2">John Dorf</h3>
                                                </div>
                                                <span className="text-right">2 weeks ago</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="item ii">
                                    <div className="property-wrap ftco-animate">
                                        <a href="test" className="img"
                                           style={{backgroundImage: 'url(images/work-2.jpg)'}}>
                                            <div className="rent-sale">
                                                <span className="rent">Rent</span>
                                            </div>
                                            <p className="price"><span className="old-price">800,000</span><span
                                                className="orig-price">$3,050<small> / mo</small></span></p>
                                        </a>
                                        <div className="text">
                                            <ul className="property_list">
                                                <li><span className="flaticon-bed"/>3</li>
                                                <li><span className="flaticon-bathtub"/>2</li>
                                                <li><span className="flaticon-floor-plan"/>1,878 sqft</li>
                                            </ul>
                                            <h3><a href="test">The Blue Sky Home</a></h3>
                                            <span className="location">Oakland</span>
                                            <a href="test"
                                               className="d-flex align-items-center justify-content-center btn-custom">
                                                <span className="fa fa-link"/>
                                            </a>
                                            <div className="list-team d-flex align-items-center mt-2 pt-2 border-top">
                                                <div className="d-flex align-items-center">
                                                    <div className="img"
                                                         style={{backgroundImage: 'url(images/person_1.jpg)'}}/>
                                                    <h3 className="ml-2">John Dorf</h3>
                                                </div>
                                                <span className="text-right">2 weeks ago</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="item ii">
                                    <div className="property-wrap ftco-animate">
                                        <a href="test" className="img"
                                           style={{backgroundImage: 'url(images/work-3.jpg'}}>
                                            <div className="rent-sale">
                                                <span className="rent">Rent</span>
                                            </div>
                                            <p className="price"><span
                                                className="orig-price">$300<small> / mo</small></span></p>
                                        </a>
                                        <div className="text">
                                            <ul className="property_list">
                                                <li><span className="flaticon-bed"/>3</li>
                                                <li><span className="flaticon-bathtub"/>2</li>
                                                <li><span className="flaticon-floor-plan"/>1,878 sqft</li>
                                            </ul>
                                            <h3><a href="test">The Blue Sky Home</a></h3>
                                            <span className="location">Oakland</span>
                                            <a href="test"
                                               className="d-flex align-items-center justify-content-center btn-custom">
                                                <span className="fa fa-link"/>
                                            </a>
                                            <div className="list-team d-flex align-items-center mt-2 pt-2 border-top">
                                                <div className="d-flex align-items-center">
                                                    <div className="img"
                                                         style={{backgroundImage: 'url(images/person_1.jpg'}}/>
                                                    <h3 className="ml-2">John Dorf</h3>
                                                </div>
                                                <span className="text-right">2 weeks ago</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="item ii">
                                    <div className="property-wrap ftco-animate">
                                        <a href="test" className="img"
                                           style={{backgroundImage: 'url(images/work-4.jpg'}}>
                                            <div className="rent-sale">
                                                <span className="rent">Rent</span>
                                            </div>
                                            <p className="price"><span
                                                className="orig-price">$300<small> / mo</small></span></p>
                                        </a>
                                        <div className="text">
                                            <ul className="property_list">
                                                <li><span className="flaticon-bed"/>3</li>
                                                <li><span className="flaticon-bathtub"/>2</li>
                                                <li><span className="flaticon-floor-plan"/>1,878 sqft</li>
                                            </ul>
                                            <h3><a href="test">The Blue Sky Home</a></h3>
                                            <span className="location">Oakland</span>
                                            <a href="test"
                                               className="d-flex align-items-center justify-content-center btn-custom">
                                                <span className="fa fa-link"/>
                                            </a>
                                            <div className="list-team d-flex align-items-center mt-2 pt-2 border-top">
                                                <div className="d-flex align-items-center">
                                                    <div className="img"
                                                         style={{backgroundImage: 'url(images/person_1.jpg'}}/>
                                                    <h3 className="ml-2">John Dorf</h3>
                                                </div>
                                                <span className="text-right">2 weeks ago</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="item ii">
                                    <div className="property-wrap ftco-animate">
                                        <a href="test" className="img"
                                           style={{backgroundImage: 'url(images/work-5.jpg'}}>
                                            <div className="rent-sale">
                                                <span className="rent">Rent</span>
                                            </div>
                                            <p className="price"><span
                                                className="orig-price">$300<small> / mo</small></span></p>
                                        </a>
                                        <div className="text">
                                            <ul className="property_list">
                                                <li><span className="flaticon-bed"/>3</li>
                                                <li><span className="flaticon-bathtub"/>2</li>
                                                <li><span className="flaticon-floor-plan"/>1,878 sqft</li>
                                            </ul>
                                            <h3><a href="test">The Blue Sky Home</a></h3>
                                            <span className="location">Oakland</span>
                                            <a href="test"
                                               className="d-flex align-items-center justify-content-center btn-custom">
                                                <span className="fa fa-link"/>
                                            </a>
                                            <div className="list-team d-flex align-items-center mt-2 pt-2 border-top">
                                                <div className="d-flex align-items-center">
                                                    <div className="img"
                                                         style={{backgroundImage: 'url(images/person_1.jpg'}}/>
                                                    <h3 className="ml-2">John Dorf</h3>
                                                </div>
                                                <span className="text-right">2 weeks ago</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/*WORKFLOW*/}
            <section className="ftco-section services-section bg-darken" id="workflow">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-12 text-center heading-section heading-section-white ftco-animate">
                            <span className="subheading">Work flow</span>
                            <h2 className="mb-3">How it works ?</h2>
                        </div>
                    </div>
                    <div className="row">

                        <div className="col-lg-3 col-md-3 col-sm-3  p-3">
                            <div style={{position: "relative", width: "150px", marginLeft: "52px"}}>
                                <Goo intensity={"medium"}>

                                    <svg style={{animation: " 9s linear 0s infinite normal none running rotate_back"}}
                                         width="200">

                                        <circle cx="50%" cy="50%" r="50" fill="#2a9d48"
                                                style={{animation: "12s ease-in-out -3s infinite alternate none running blob_four"}}/>
                                        <circle cx="50%" cy="50%" r="36" fill="#2a9d48"
                                                style={{animation: "9s ease-in-out -3s infinite alternate none running blob_three"}}/>
                                        <circle cx="50%" cy="50%" r="30" fill="#2a9d48"
                                                style={{animation: "6s ease-in-out -3s infinite alternate none running blob_two"}}/>
                                        <circle cx="50%" cy="50%" r="34" fill="#2a9d48"
                                                style={{animation: "3s ease-in-out -3s infinite alternate none running blob_one"}}/>

                                    </svg>

                                </Goo>
                            </div>
                            <div className="icon mb-1 d-flex align-items-center justify-content-center" style={{
                                position: 'absolute',
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%,-100px)"
                            }}>
                                <span className="text-white font-weight-bold" style={{fontSize: "24px"}}>01</span>
                                {/*<img src="images/blob.svg" alt=""/>*/}
                            </div>
                            <h3 className="text-white text-center">Evaluate Property</h3>
                            <p className="text-center">A small river named Duden flows by their place and supplies it
                                with the necessary
                                regelialia.</p>


                        </div>

                        <div className="col-lg-3 col-md-3 col-sm-3  p-3">
                            <div style={{position: "relative", width: "150px", marginLeft: "52px"}}>
                                <Goo intensity={"medium"}>

                                    <svg style={{animation: " 9s linear 0s infinite normal none running rotate_back"}}
                                         width="200">

                                        <circle cx="50%" cy="50%" r="50" fill="#2a9d48"
                                                style={{animation: "12s ease-in-out -3s infinite alternate none running blob_four"}}/>
                                        <circle cx="50%" cy="50%" r="36" fill="#2a9d48"
                                                style={{animation: "9s ease-in-out -3s infinite alternate none running blob_three"}}/>
                                        <circle cx="50%" cy="50%" r="30" fill="#2a9d48"
                                                style={{animation: "6s ease-in-out -3s infinite alternate none running blob_two"}}/>
                                        <circle cx="50%" cy="50%" r="34" fill="#2a9d48"
                                                style={{animation: "3s ease-in-out -3s infinite alternate none running blob_one"}}/>

                                    </svg>

                                </Goo>
                            </div>
                            <div className="icon mb-1 d-flex align-items-center justify-content-center" style={{
                                position: 'absolute',
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%,-100px)"
                            }}>
                                <span className="text-white font-weight-bold" style={{fontSize: "24px"}}>02</span>
                                {/*<img src="images/blob.svg" alt=""/>*/}
                            </div>
                            <h3 className="text-white text-center">Meet Your Agent</h3>
                            <p className="text-center">A small river named Duden flows by their place and supplies it
                                with the necessary
                                regelialia.</p>


                        </div>

                        <div className="col-lg-3 col-md-3 col-sm-3  p-3">
                            <div style={{position: "relative", width: "150px", marginLeft: "52px"}}>
                                <Goo intensity={"medium"}>

                                    <svg style={{animation: " 9s linear 0s infinite normal none running rotate_back"}}
                                         width="200">

                                        <circle cx="50%" cy="50%" r="50" fill="#2a9d48"
                                                style={{animation: "12s ease-in-out -3s infinite alternate none running blob_four"}}/>
                                        <circle cx="50%" cy="50%" r="36" fill="#2a9d48"
                                                style={{animation: "9s ease-in-out -3s infinite alternate none running blob_three"}}/>
                                        <circle cx="50%" cy="50%" r="30" fill="#2a9d48"
                                                style={{animation: "6s ease-in-out -3s infinite alternate none running blob_two"}}/>
                                        <circle cx="50%" cy="50%" r="34" fill="#2a9d48"
                                                style={{animation: "3s ease-in-out -3s infinite alternate none running blob_one"}}/>

                                    </svg>

                                </Goo>
                            </div>
                            <div className="icon mb-1 d-flex align-items-center justify-content-center" style={{
                                position: 'absolute',
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%,-100px)"
                            }}>
                                <span className="text-white font-weight-bold" style={{fontSize: "24px"}}>03</span>
                                {/*<img src="images/blob.svg" alt=""/>*/}
                            </div>
                            <h3 className="text-white text-center">Close The Deal</h3>
                            <p className="text-center">A small river named Duden flows by their place and supplies it
                                with the necessary
                                regelialia.</p>


                        </div>

                        <div className="col-lg-3 col-md-3 col-sm-3  p-3">
                            <div style={{position: "relative", width: "150px", marginLeft: "52px"}}>
                                <Goo intensity={"medium"}>

                                    <svg style={{animation: " 9s linear 0s infinite normal none running rotate_back"}}
                                         width="200">

                                        <circle cx="50%" cy="50%" r="50" fill="#2a9d48"
                                                style={{animation: "12s ease-in-out -3s infinite alternate none running blob_four"}}/>
                                        <circle cx="50%" cy="50%" r="36" fill="#2a9d48"
                                                style={{animation: "9s ease-in-out -3s infinite alternate none running blob_three"}}/>
                                        <circle cx="50%" cy="50%" r="30" fill="#2a9d48"
                                                style={{animation: "6s ease-in-out -3s infinite alternate none running blob_two"}}/>
                                        <circle cx="50%" cy="50%" r="34" fill="#2a9d48"
                                                style={{animation: "3s ease-in-out -3s infinite alternate none running blob_one"}}/>

                                    </svg>

                                </Goo>
                            </div>
                            <div className="icon mb-1 d-flex align-items-center justify-content-center" style={{
                                position: 'absolute',
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%,-100px)"
                            }}>
                                <span className="text-white font-weight-bold" style={{fontSize: "24px"}}>04</span>
                                {/*<img src="images/blob.svg" alt=""/>*/}
                            </div>
                            <h3 className="text-white text-center">Have Your Property</h3>
                            <p className="text-center">A small river named Duden flows by their place and supplies it
                                with the necessary
                                regelialia.</p>


                        </div>


                    </div>

                </div>
            </section>

            {/*TESTIMONIES*/}
            <section className="ftco-section testimony-section"
                     style={{background: '#10101c', borderTop: '', height: "100vh"}} id="happyclients">
                <div className="container">
                    <div className="row justify-content-center mb-5">
                        <div className="col-md-7 text-center heading-section ftco-animate">
                            <span className="subheading">Testimonial</span>
                            <h2 className="mb-3 text-white">Happy Clients</h2>
                        </div>
                    </div>
                    <div className="row ftco-animate">
                        <div className="col-md-12">
                            <div className="carousel-testimony owl-carousel">
                                <div className="item">
                                    <div className="testimony-wrap py-4">
                                        <div className="text">
                                            <span className="fa fa-quote-left"/>
                                            <p className="mb-4">Far far away, behind the word mountains, far from the
                                                countries Vokalia and Consonantia, there live the blind texts.</p>
                                            <div className="d-flex align-items-center">
                                                <div className="user-img"
                                                     style={{backgroundImage: 'url(images/person_1.jpg)'}}/>
                                                <div className="pl-3">
                                                    <p className="name">Roger Scott</p>
                                                    <span className="position">Marketing Manager</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="testimony-wrap py-4">
                                        <div className="text">
                                            <span className="fa fa-quote-left"/>
                                            <p className="mb-4">Far far away, behind the word mountains, far from the
                                                countries Vokalia and Consonantia, there live the blind texts.</p>
                                            <div className="d-flex align-items-center">
                                                <div className="user-img"
                                                     style={{backgroundImage: 'url(images/person_2.jpg)'}}/>
                                                <div className="pl-3">
                                                    <p className="name">Roger Scott</p>
                                                    <span className="position">Marketing Manager</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="testimony-wrap py-4">
                                        <div className="text">
                                            <span className="fa fa-quote-left"/>
                                            <p className="mb-4">Far far away, behind the word mountains, far from the
                                                countries Vokalia and Consonantia, there live the blind texts.</p>
                                            <div className="d-flex align-items-center">
                                                <div className="user-img"
                                                     style={{backgroundImage: 'url(images/person_3.jpg)'}}/>
                                                <div className="pl-3">
                                                    <p className="name">Roger Scott</p>
                                                    <span className="position">Marketing Manager</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="testimony-wrap py-4">
                                        <div className="text">
                                            <span className="fa fa-quote-left"/>
                                            <p className="mb-4">Far far away, behind the word mountains, far from the
                                                countries Vokalia and Consonantia, there live the blind texts.</p>
                                            <div className="d-flex align-items-center">
                                                <div className="user-img"
                                                     style={{backgroundImage: 'url(images/person_1.jpg)'}}/>
                                                <div className="pl-3">
                                                    <p className="name">Roger Scott</p>
                                                    <span className="position">Marketing Manager</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="testimony-wrap py-4">
                                        <div className="text">
                                            <span className="fa fa-quote-left"/>
                                            <p className="mb-4">Far far away, behind the word mountains, far from the
                                                countries Vokalia and Consonantia, there live the blind texts.</p>
                                            <div className="d-flex align-items-center">
                                                <div className="user-img"
                                                     style={{backgroundImage: 'url(images/person_2.jpg)'}}/>
                                                <div className="pl-3">
                                                    <p className="name">Roger Scott</p>
                                                    <span className="position">Marketing Manager</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer/>
        </div>
    );
}

export default App;
